import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { Project, ProjectSearchInput } from '../models/project';

/**
 * <p>
 * API endpoints that cover all project related CRUD calls
 */

export const projectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchProjects: builder.query<PaginationResponse<Project>, ProjectSearchInput>({
      query: (input: ProjectSearchInput) => ({
        url: encodeURI(
          `/indirect/project/search?bringClose=${input.bringClosed}&searchTerm=${input.searchTerm}&page=${input.page}&size=${input.size}&sortKey=${input.sortKey}&sortDirection=${input.sortDirection}`,
        ),
      }),
      providesTags: ['Projects'],
    }),
  }),
});

export const { useSearchProjectsQuery } = projectApi;
